<template>
  <div>
    <Head title="Work Orders-Boms" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/work-orders">
        Work Orders
      </Link>
      <span class="text-orange-400 font-medium">/</span>Boms
    </h1>
    <h1 class="mb-2 text-1xl">
      <strong>WO NUMBER : </strong> {{ workOrder.WO_number }}
    </h1>
    <h1 class="mb-2 text-1xl">
      <strong>PRODUCT : </strong> {{ workOrder.part_description }}
    </h1>
    <h1 class="mb-2 text-1xl">
      <strong>QUANTITY : </strong>{{ workOrder.quantity }}
    </h1>
    <div class="flex items-center justify-between mb-6 mt-6">
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
      <Link class="btn-orange" :href="`/work-orders/${workOrder.id}/boms/create`">
        <span>Add</span>
        <span class="hidden md:inline">&nbsp;Bom</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3">BOM per Unit Product</th>
          <th class="pb-3 pt-3 px-3">Quantity Required</th>
          <th class="pb-3 pt-3 px-3">Quantity Issued</th>
          <th class="pb-3 pt-3 px-3">UOM</th>
        </tr>
        <tr v-for="bom in boms.data" :key="bom.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${workOrder.id}/boms/${bom.id}/edit`" tabindex="-1">
              {{ bom.part_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${workOrder.id}/boms/${bom.id}/edit`" tabindex="-1">
              {{ bom.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${workOrder.id}/boms/${bom.id}/edit`" tabindex="-1">
              {{ bom.bom_per_unit_product }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${workOrder.id}/boms/${bom.id}/edit`" tabindex="-1">
              {{ bom.quantity_required }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${workOrder.id}/boms/${bom.id}/edit`" tabindex="-1">
              {{ bom.quantity_issued }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${workOrder.id}/boms/${bom.id}/edit`" tabindex="-1">
              {{ bom.unit_of_measure }}
            </Link>
          </td>
        </tr>
        <tr v-if="boms.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="boms.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Icon,
    SearchWithDateRange,
    DateRange,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    workOrder: Object,
    boms: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/work-orders/${workOrder.id}/boms`, pickBy(this.form), {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
